function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xd8bad4;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;




    var itemsPositionsObject = { p: { x: 370, y: 419, w: 37, h: 47, n: "p" }, m: { x: 421, y: 466, w: 37, h: 47, n: "m" }, s: { x: 364, y: 227, w: 37, h: 47, n: "s" }, c: { x: 422, y: 274, w: 37, h: 47, n: "c" }, l: { x: 421, y: 465, w: 37, h: 47, n: "l" }, e: { x: 379, y: 150, w: 37, h: 47, n: "e" }, r: { x: 370, y: 420, w: 37, h: 47, n: "r" }, errore_8: { x: 419, y: 463, w: 35, h: 46, n: "errore_8" }, errore_7: { x: 368, y: 418, w: 35, h: 46, n: "errore_7" }, errore_6: { x: 419, y: 363, w: 35, h: 46, n: "errore_6" }, errore_5: { x: 369, y: 317, w: 35, h: 46, n: "errore_5" }, errore_4: { x: 420, y: 272, w: 35, h: 46, n: "errore_4" }, errore_3: { x: 362, y: 225, w: 35, h: 46, n: "errore_3" }, errore_2: { x: 427, y: 192, w: 35, h: 46, n: "errore_2" }, errore_1: { x: 377, y: 148, w: 35, h: 46, n: "errore_1" }, errore_0: { x: 420, y: 97, w: 35, h: 46, n: "errore_0" }, n_3: { x: 127, y: 365, w: 213, h: 67, n: "n_3" }, n_2: { x: 127, y: 298, w: 213, h: 67, n: "n_2" }, n_1: { x: 127, y: 231, w: 213, h: 67, n: "n_1" }, n_0: { x: 127, y: 164, w: 213, h: 67, n: "n_0" }, griglia: { x: 10, y: 0, w: 461, h: 600, n: "griglia" } };
    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);

    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 4;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(530, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('lavagna', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        //  game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 405;
        sprites.btn_gioca.y = 503;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        //  counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    //
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var buttonsContainer = new Container();
    var cursorIndex = 0;

    container.addChild(buttonsContainer);
    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);

    var sceneElements = {};
    var scaffoldsNames = ['01', '02', '03'];
    var currentScaffoldName;
    var answers = {
        '01': { answerchars: 'pesc', charsMap: 'oeuscaipm', items: [] },
        '02': { answerchars: 'resc', charsMap: 'oeuscairm', items: [] },
        '03': { answerchars: 'mlsr', charsMap: 'meuscairl', items: [] }
    };

    var chars = ['c', 'e', 'l', 'm', 'p', 'r', 's'];

    initScene();

    function initScene() {
        var i;
        var itemName;
        var spriteItem;
        var pos;

        var graphics;

        for (i = 0; i < scaffoldsNames.length; i++) {
            itemName = scaffoldsNames[i];
            spriteItem = game.sprites['griglia_' + itemName];
            pos = positions.griglia;
            spriteItem.position.set(pos.x, pos.y);
            container.addChild(spriteItem);
            sceneElements["griglia_" + itemName] = spriteItem;
            for (ii = 0; ii < 4; ii++) {
                spriteItem = game.sprites[itemName + '_' + ii];
                pos = positions["n_" + ii];
                spriteItem.position.set(pos.x, pos.y);
                container.addChild(spriteItem);
                sceneElements[itemName + '_' + ii] = spriteItem;
                answers[itemName].items.push(spriteItem);

            }
        }

        for (i = 0; i < chars.length; i++) {
            spriteItem = game.sprites[chars[i]];
            container.addChild(spriteItem);
            sceneElements[chars[i]] = spriteItem;
        }

        for (i = 0; i < 9; i++) {
            spriteItem = new Sprite(game.sprites.errore.texture);
            pos = positions['errore_' + i];
            spriteItem.position.set(pos.x, pos.y);

            spriteItem.interactive = true;
            spriteItem.buttonMode = true;
            buttonsContainer.addChild(spriteItem);
            sceneElements['errore_' + i] = spriteItem;
            spriteItem.alpha = 0;
        }
        spriteItem = new Sprite(game.sprites.errore.texture);
        container.addChild(spriteItem);
        sceneElements.errore = spriteItem;

    }


    function clear() {


    }

    function reset() {
        scaffoldsNames = _.shuffle(scaffoldsNames);
        setState('newScaffold');
    }

    function resetScaffolds() {
        var i, ii;

        for (i = 0; i < scaffoldsNames.length; i++) {
            itemName = scaffoldsNames[i];
            var isCurrent = itemName === currentScaffoldName;
            sceneElements["griglia_" + itemName].visible = isCurrent;
            for (ii = 0; ii < 4; ii++) {
                sceneElements[itemName + '_' + ii].alpha = 0;
            }
        }


        for (i = 0; i < chars.length; i++) {
            var char = chars[i];
            var charMap = answers[currentScaffoldName].charsMap;
            var answerchars = answers[currentScaffoldName].answerchars;
            var charposIndex = charMap.indexOf(char);
            var inAnswer = answerchars.indexOf(char) >= 0;

            if (charposIndex >= 0 && inAnswer) {
                var pos = positions['errore_' + charposIndex];
                sceneElements[char].position.set(pos.x, pos.y);
            }

            sceneElements[char].alpha = 0;
        }
        for (i = 0; i < 9; i++) {
            sceneElements['errore_' + i].visible = true;
        }
        sceneElements.errore.alpha = 0;
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newScaffold':


                scaffoldsNames.push(scaffoldsNames.shift());

                currentScaffoldName = scaffoldsNames[0];

                cursorIndex = 0;
                resetScaffolds();


                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {
        var i;
        var pos;
        if (currentState === "ready") {


            var char = '';
            var charIndex = -1;
            for (i = 0; i < 9; i++) {

                if (sceneElements['errore_' + i] === e.target) {
                    char = answers[currentScaffoldName].charsMap[i];
                    charIndex = i;
                }
            }

            if (char === '') {
                return false;
            }


            var ok = answers[currentScaffoldName].answerchars[cursorIndex] === char;


            if (ok) {
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerOk'));
                sceneElements['errore_' + charIndex].visible = false;
                tl.to(sceneElements[currentScaffoldName + '_' + cursorIndex], 0.75, {
                    pixi: { alpha: 1 }
                }).to(sceneElements[char], 0.75, {
                    pixi: { alpha: 1 }
                }, 0).addCallback(okComplete);
                loopSequence = [renderAlways];

            } else {
                pos = positions['errore_' + charIndex];
                sceneElements.errore.position.set(pos.x, pos.y);
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerWrong'));
                tl.to(sceneElements.errore, 0.75, {
                    pixi: { alpha: 1 }
                }).addCallback(wrongComplete);
                loopSequence = [renderAlways];
            }


        }

    }

    function okComplete() {

        cursorIndex++;
        if (cursorIndex < 4) {
            setState('ready');
        }

        theGame.cycleGame();
        loopSequence = [renderOnce];


    }

    function wrongComplete() {
        sceneElements.errore.alpha = 0;
        theGame.cycleGame();
        loopSequence = [renderOnce];
        setState('ready');
    }
}